import { render, staticRenderFns } from "./build_familyconnect_dashboard.vue?vue&type=template&id=640f3092"
import script from "./build_familyconnect_dashboard.vue?vue&type=script&lang=js"
export * from "./build_familyconnect_dashboard.vue?vue&type=script&lang=js"
import style0 from "./build_familyconnect_dashboard.vue?vue&type=style&index=0&id=640f3092&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports